import { type GridRowId, useGridApiRef } from "@mui/x-data-grid-pro";
import { createElement, useMemo, useState } from "react";

import DataGridFilterControl from "./DataGridFilterControl";
import useFilteredDataRowCount from "./useFilteredDataRowCount";
import useGridQuickFilterModel from "./useGridQuickFilterModel";

type DataRow = { id?: GridRowId; uuid?: GridRowId; isDummyRow?: boolean };

export default function useCoAppDataGridFilters(
	rows: DataRow[],
	loading: boolean,
) {
	const apiRef = useGridApiRef();
	const { gridFilterModel, onFilterModelChange, quickFilterSearchProps } = useGridQuickFilterModel();
	const { visibleRowCount, visibleRuleCount } = useFilteredDataRowCount(apiRef, rows, loading, gridFilterModel);
	const [filterButtonEl, setFilterButtonEl] = useState<HTMLButtonElement | null>(null);
	const hasActiveFilter = (gridFilterModel.items?.length ?? 0) > 0;

	const filterControl = useMemo(
		() => createElement(DataGridFilterControl, {
			hasActiveFilter,
			onOpenFilterPanel: () => apiRef.current?.showFilterPanel(),
			buttonRef: setFilterButtonEl,
		}),
		[apiRef, hasActiveFilter],
	);

	const filterPanelSlotProps = useMemo(
		() => ({
			panel: {
				target: filterButtonEl ?? undefined,
			},
		}),
		[filterButtonEl],
	);

	return {
		apiRef,
		gridFilterModel,
		onFilterModelChange,
		quickFilterSearchProps,
		visibleRowCount,
		visibleRuleCount,
		filterButtonEl,
		hasActiveFilter,
		filterControl,
		filterPanelSlotProps,
	};
}
